/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementDetailsViewModel } from "../types/CourseRegistrationManagementDetailsViewModel.ts";
import { courseRegistrationManagementAttachmentGroupViewModelSchema } from "./courseRegistrationManagementAttachmentGroupViewModelSchema.ts";
import { eDocumentationStatusSchema } from "./eDocumentationStatusSchema.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";
import { eForeignStatusSchema } from "./eForeignStatusSchema.ts";
import { eUserRoleSchema } from "./eUserRoleSchema.ts";

export const courseRegistrationManagementDetailsViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da matrícula.")),
  personId: z.optional(
    z.number().int().describe("ID da pessoa vinculada à matrícula."),
  ),
  userId: z.optional(
    z.number().int().describe("ID do usuário vinculado à matrícula."),
  ),
  userRoleId: z.optional(
    z
      .lazy(() => eUserRoleSchema)
      .describe(
        "1 = Master | 2 = Administrator | 3 = Polo | 4 = Basic | 5 = Relationship | 6 = Planning | 7 = Secretary | 8 = Communication | 9 = Financial | 10 = Visitor | 11 = API | 12 = StudentCare | 13 = Valoriza | 14 = Leads | 15 = Faculty | 16 = Orientation | 17 = Exams | 18 = BusinessCore | 19 = Contracts | 20 = HumanResources | 21 = Audiovisual | 22 = ScholarshipTeam | 23 = Translation | 24 = Transmission | 25 = RelationshipTR | 26 = International | ",
      ),
  ),
  personFullName: z
    .string()
    .describe("Nome completo da pessoa matriculada.")
    .nullish(),
  personAlias: z
    .string()
    .describe("Apelido da pessoa matriculada. Opcional.")
    .nullish(),
  personEmail: z
    .string()
    .describe("E-mail principal da pessoa matriculada.")
    .nullish(),
  isPCD: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa é portadora de deficiência (PCD)."),
  ),
  cellPhone: z
    .string()
    .describe("Número de celular da pessoa. Opcional.")
    .nullish(),
  homePhone: z
    .string()
    .describe("Telefone residencial da pessoa. Opcional.")
    .nullish(),
  address: z
    .string()
    .describe("Endereço formatado da pessoa. Opcional.")
    .nullish(),
  workPhone: z
    .string()
    .describe("Telefone comercial da pessoa. Opcional.")
    .nullish(),
  cpf: z.string().describe("CPF da pessoa. Opcional.").nullish(),
  rg: z.string().describe("RG da pessoa. Opcional.").nullish(),
  passport: z
    .string()
    .describe("Número do passaporte da pessoa. Opcional.")
    .nullish(),
  courseId: z.optional(
    z.number().int().describe("ID do curso ao qual a matrícula pertence."),
  ),
  courseName: z.string().describe("Nome do curso.").nullish(),
  classStudentId: z.optional(z.number().int().describe("ID da turma.")),
  classStudentName: z.string().describe("Nome da turma.").nullish(),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa vinculada à matrícula. Opcional.")
    .nullish(),
  poloId: z
    .number()
    .int()
    .describe("ID do polo vinculado à matrícula. Opcional.")
    .nullish(),
  poloName: z
    .string()
    .describe("Nome do polo vinculado à matrícula. Opcional.")
    .nullish(),
  enrollmentStatus: z.optional(
    z
      .lazy(() => eEnrollmentStatusSchema)
      .describe(
        "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
      ),
  ),
  documentationStatus: z.optional(
    z
      .lazy(() => eDocumentationStatusSchema)
      .describe(
        "0 = Pending | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação da matrícula. Opcional.")
    .nullish(),
  enrollmentByScholarshipLink: z.optional(
    z
      .boolean()
      .describe("Indica se a matrícula foi realizada via link de bolsa."),
  ),
  studentNote: z
    .string()
    .describe("Observação interna sobre o aluno. Opcional.")
    .nullish(),
  isForeign: z.optional(
    z.boolean().describe("Indica se o aluno é estrangeiro."),
  ),
  foreignStatus: z.optional(
    z
      .lazy(() => eForeignStatusSchema)
      .describe(
        "1 = Approved | 2 = PendingDocument | 3 = EquivalenceMade | 4 = Cancelled | ",
      ),
  ),
  courseHasMonograph: z.optional(
    z.boolean().describe("Indica se o curso possui monografia configurada."),
  ),
  isPoloAllowedToCancelEnrollment: z.optional(
    z
      .boolean()
      .describe("Indica se o polo tem permissão para cancelar a matrícula."),
  ),
  communicationLanguage: z
    .string()
    .describe("Idioma de comunicação preferencial do aluno (ex.: pt-BR).")
    .nullish(),
  lastStatusHistoryId: z.optional(
    z
      .number()
      .int()
      .describe("ID do último registro de histórico de status da matrícula."),
  ),
  lastStatusReasonName: z
    .string()
    .describe("Nome do motivo do último status registrado. Opcional.")
    .nullish(),
  lastStatusSubReasonName: z
    .string()
    .describe("Nome do submotivo do último status registrado. Opcional.")
    .nullish(),
  lastStatusObservation: z
    .string()
    .describe("Observação do último status registrado. Opcional.")
    .nullish(),
  attachments: z
    .array(
      z.lazy(() => courseRegistrationManagementAttachmentGroupViewModelSchema),
    )
    .describe(
      "Lista de grupos de documentos anexados à matrícula, agrupados por tipo.",
    )
    .nullish(),
}) as unknown as ToZod<CourseRegistrationManagementDetailsViewModel>;
